import { AdminMenuUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const fetchAllconstructs = (page: number) => {
  return new AdminMenuUseCase(
    `/construto/pageConstruto?page=${page}`,
    makeAxiosHttpClient()
  )
}
export const saveConstruct = () => {
  return new AdminMenuUseCase(`/construto/saveConstruto`, makeAxiosHttpClient())
}
export const updateConstruct = () => {
  return new AdminMenuUseCase(
    `/construto/updateConstruto`,
    makeAxiosHttpClient()
  )
}
